export enum ENUM_ORGANIZATION_STATUS {
  ACTIVE = "active",
  PENDING = "pending",
}
